import { RequestConfig } from "./types";

export class HttpClient {
    constructor(private config: RequestConfig) {}
  
    async post<T>(endpoint: string, data: any): Promise<T> {
      const response = await fetch(`${this.config.baseURL}${endpoint}`, {
        method: 'POST',
        headers: this.config.headers,
        body: JSON.stringify(data)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      return response.json();
    }
  }